import { marketplaceWhitelist } from './constants';

const getMarketplaceHasAccess = (orgId, whitelist) => true;

const state = {
  config: {
    hasMarketplaceAccess: false,
  },
};

const mutations = {
  LOAD_DATA(state, data) {
    state = data;
  },
};

const actions = {
  load_config: ({ commit, rootGetters }, payload) => {
    const hasMarketplaceAccess = getMarketplaceHasAccess(
      payload,
      marketplaceWhitelist
    );

    const configData = {
      config: {
        hasMarketplaceAccess,
      },
    };

    try {
      commit('LOAD_DATA', configData);
    } catch (error) {
      commit('LOAD_DATA', {});
    }
  },
};

const getters = {
  get_config(state) {
    return state;
  },
  get_marketplace_access(state, getters, root) {
    return getMarketplaceHasAccess(root.auth.user?.orgId, marketplaceWhitelist);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
